module.exports = __webpack_public_path__ + "static/media/Lato-regular.77f286e4.eot";